/**
 * What Agent Alex says around the end of a mission (docs/design/story.md): as the mission report
 * opens, so the jump from the puzzle to the results is explained, not abrupt (QA 2026-10-11), and
 * back at the elevator, where the story moves on to the next foe. The first report explains the
 * stars; later ones are short and honest about the result. Recorded whole (voice_sheets.py).
 */
export const REPORT = {
  /** The first mission report ever: what the stars mean. */
  first: [
    '[warm] Mission complete! This is your mission report. Each star shows how many words had a strong r. Two stars open the next floor of the building.',
  ],
  /** The mission opened the next floor. */
  unlocked: [
    '[cheerful] Mission complete! You opened the next floor.',
    '[excited] Great work, agent! The next floor is open.',
  ],
  /** Two or more stars again (the next floor was already open). */
  passed: [
    '[warm] Mission report! Nice work on those r’s.',
    '[cheerful] Here’s your report. Strong work!',
  ],
  /** One star: honest, and what opens the next floor. */
  practice: [
    '[encouraging] Here’s your report. A few more strong r’s, and the next floor opens.',
    '[warm] Mission report. Every try makes your r stronger. Let’s keep going.',
  ],
} as const;

/** Back at the elevator after a mission, the story moves on. */
export const ELEVATOR_BEAT = {
  /** A foe unmasked and the next floor open. */
  next: [
    '[mysterious] One foe unmasked! But another one is hiding upstairs. Ride the elevator up when you’re ready.',
    '[mysterious] That’s one less foe in disguise. I can hear another one on the next floor.',
  ],
  /** Every floor's foe unmasked. */
  allDone: ['[excited] Every foe in the building is unmasked! Amazing work, agent.'],
} as const;
